"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var react_1 = require("react");
var index_1 = require("../index");
function ContextMenu(_a) {
    var items = _a.items, children = _a.children;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = react_1.useState(null), positions = _c[0], setPositions = _c[1];
    var onContextMenu = function (e) {
        e.preventDefault();
        setPositions({
            y: e.pageY,
            x: e.pageX
        });
        setIsOpen(true);
    };
    var onOutsideClick = function () {
        setIsOpen(false);
    };
    var registerEvents = function () {
        document.addEventListener("mousedown", onOutsideClick);
        document.addEventListener("touchstart", onOutsideClick);
    };
    var unregisterEvents = function () {
        document.removeEventListener("mousedown", onOutsideClick);
        document.removeEventListener("touchstart", onOutsideClick);
    };
    react_1.useEffect(function () {
        registerEvents();
        return unregisterEvents;
    });
    var setRef = function (el) {
        if (el) {
            var rect = el.getBoundingClientRect();
            if ((positions.y + rect.height) > (window.innerHeight + window.pageYOffset)) {
                setPositions({ x: positions.x, y: positions.y - rect.height });
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        isOpen && (React.createElement(index_1.Portal, null,
            React.createElement("div", { ref: setRef, className: theme.menu, style: { top: positions.y, left: positions.x } }, items.map(function (item) { return (React.createElement("div", { key: item.label, className: theme.item, onMouseDown: item.onClick }, item.label)); })))),
        React.Children.map(children, (function (child) {
            if (!child) {
                return null;
            }
            return React.cloneElement(child, tslib_1.__assign({ onContextMenu: onContextMenu }, child.props));
        }))));
}
exports.default = React.memo(ContextMenu);
